import React from 'react';

import CSS from './styles.css';

import { ItemEdit as IEIcon } from 'Shared/Icons';


const AddNoteOptionViews = ({ openNoteEditor }) => {
  return (
    <section className={  CSS['container'] }>
      <button className={ CSS['add-note'] } onClick={ openNoteEditor }>
        <IEIcon fill="#ffffff" />
        <span className={ CSS['add-note__text'] }>Add Note</span>
      </button>
    </section>
  );
};


export default AddNoteOptionViews;
